import { render, staticRenderFns } from "./CortaCorrientePantalla.vue?vue&type=template&id=1407c720&scoped=true&"
import script from "./CortaCorrientePantalla.vue?vue&type=script&lang=ts&"
export * from "./CortaCorrientePantalla.vue?vue&type=script&lang=ts&"
import style0 from "./CortaCorrientePantalla.vue?vue&type=style&index=0&id=1407c720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1407c720",
  null
  
)

export default component.exports